import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { RegistrationStatusEntity } from './registration-statuses.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class RegistrationStatusService {
	private httpClient = inject(HttpClient);

	private registrationStatuses$: Observable<RegistrationStatusEntity[]> | null = null;

	list(): Observable<RegistrationStatusEntity[]> {
	
			return (this.registrationStatuses$ ??= this.httpClient
				.get<RegistrationStatusEntity[]>('api/common/registration-statuses')
				.pipe(shareReplay(1)));
		}
}
